module.exports = __webpack_public_path__ + "media/images/emails/existing_org_new_user_message/read-with-nicklpass-e6ca4799d83a5afa02c1393e0025bfab.png";